import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_26nge8afju: FaireBrandEntity = {
  token: "b_26nge8afju",
  type: "brand",
  name: "millie + roo LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/e96c311857ad13b0c43b6d719ef7ea4dad4c38bf978a096e637dc574ecd7eb22.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/bfa97481460c679e034b80aafa33423f1890d7fcc20ef2b3572650bb01a51504.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e96c311857ad13b0c43b6d719ef7ea4dad4c38bf978a096e637dc574ecd7eb22.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bfa97481460c679e034b80aafa33423f1890d7fcc20ef2b3572650bb01a51504.jpeg",
  location: "Napa Valley, CA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 27,
  isInsider: true,
  description:
    "millie+roo LLC is a woman-owned and operated line of baby, children and adult apparel. The not so basic basics we all love. With style and comfort in mind from those first moments on earth, we have created the sweetest, softest line of clothing to grow with your little ones. We carry a wide range of products including bamboo sleepwear, daywear, swimwear, mama + mini matching, blankets and accessories! They are durable enough for play, but soft enough that your littles won't want to take them off! Our sizing range is Newborn-12/14yrs + also includes adult sizing in XS-XXL. \n\nWe pride ourselves in using only the finest quality materials. Our products are custom dyed and milled OEKO-tex certified organic cotton and organic bamboo viscose. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:02.278Z",
    importedBy: "entity-db-cli",
  },
};
